import { useEffect, useState } from 'react';
import { formatDatePicker, getPropertyPackagesStatus, getPropsTypeOfPackage, handlerGetClasificacion, handleStorage, translate } from '../utils/Common';
import { rawColumnsByMode } from '../config/columnsConfig';

export const useColumnConfig = (mode = 'packages') => {
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const defaults = rawColumnsByMode[mode]?.map((col, index) => ({ ...col, order: index })) || [];
    const stored = handleStorage('get', 'local', `columns-${mode}`);

    if (stored && Array.isArray(stored)) {
      // Merge: keep stored order/visibility, add any new columns from defaults that are missing
      const storedIds = new Set(stored.map((c) => c.id));
      const maxOrder = stored.length > 0 ? Math.max(...stored.map((c) => c.order ?? 0)) : -1;
      const newColumnsFromDefaults = defaults.filter((col) => !storedIds.has(col.id)).map((col, i) => ({ ...col, order: maxOrder + 1 + i }));
      const merged = [...stored, ...newColumnsFromDefaults];
      setColumns(merged);
      if (newColumnsFromDefaults.length > 0) {
        handleStorage('set', 'local', `columns-${mode}`, merged);
      }
    } else {
      setColumns(defaults);
    }
  }, [mode]);

  const visibleColumns = columns.filter(col => col.isVisible).sort((a, b) => a.order - b.order);

  const renderers = {
    packageNum: item => item?.Nro_Id || '',
    tracking: item => item?.NumeroTracking || '',
    customer: item => item?.Cliente || '',
    packageId: item => item?.IdPaquete || '',
    pkgStatus: (item, isOnlyText = false) => {
      if (!item?.IdEstatus) return '';
      const status = getPropertyPackagesStatus(item.IdEstatus);
      if (isOnlyText) {
        return status.text;
      }
      return (
        <span className="font-semibold" style={{ color: status.color, fontSize: "12px" }}>
          <span className="mr-1">{status.icon}</span>
          {status.text}
        </span>
      );
    },
    location: item => item?.Plataforma || '',
    doorNum: item => item?.Identificacion || '',
    pkgWeight: item =>  item?.PesoLibras ? item.PesoLibras + ' lbs' : "0 lbs",
    dateCreatePkg: item => item?.FechaCreacion ?  formatDatePicker(new Date(item.FechaCreacion), 2) : "" ,
    dateExpiredPkg: item => item?.FechaExpiracion ? formatDatePicker(new Date(item.FechaExpiracion), 2) : "" ,
    totalCost: item => item?.Precio ? `${Number(item.Precio).toFixed(2)}` : "0.00",
    sizePkg: item => handlerGetClasificacion(item?.Clasificacion) || '',
    clientId: item => item?.IdCliente || '',
    email: item => item?.Email || '',
    pkgType: (item) => {
      if (item?.IdTipoPaquete == null) return '';
      const typeInfo = getPropsTypeOfPackage(item.IdTipoPaquete);
      return typeInfo?.text ? translate(typeInfo.text) : '';
    },
  };

  return {
    columns,
    setColumns,
    visibleColumns,
    renderers,
  };
};
